@for (category of categories | keyvalue; track category) {
    <div class="category">
        <div class="category-header">
            @if (category.key != 'neutral') {
                <img [alt]="'CATEGORY.' + category.key.toUpperCase() | translate" class="category-icon"
                      ngSrc="assets/images/category/{{category.key}}.svg" height="25" width="25">
            }
            <span>{{ 'CATEGORY.' + category.key.toUpperCase() | translate }}</span>
        </div>
        <div class="tasks-grid">
            @for (task of category.value; track task) {
                <a [routerLink]="language.route('/details/' + task.id)" class="task">
                    <mat-card class="task-card">
                        <mat-card-title class="task-header">{{ task.header }}
                        </mat-card-title>
                        <mat-card-content>
                            <div class="task-content">{{ task.description }}</div>
                        </mat-card-content>
                    </mat-card>
                </a>
            }
        </div>
    </div>
}
